import React from 'react'
import { bool, func, number } from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { If, Then, Else } from '../../../sharedLegacy/components'
import { ScheduleTimerComponent } from '../../../Webinar/components'

import './WaitingRoomCountdownComponent.scss'

export const WaitingRoomCountdownComponent = ({
  webinarTimeEpoch,
  isHolding,
  isWebinarTimeInThePast,
  onLiveCountdownZero,
}) => {
  return (
    <div className="waiting-room-countdown-component">
      <If condition={isHolding || isWebinarTimeInThePast}>
        <Then>
          <div className="starting-in">
            <FormattedMessage defaultMessage="Hold on" />
          </div>
          <div className="big-message">
            {isHolding ? (
              <FormattedMessage defaultMessage="Continuing shortly" />
            ) : (
              <FormattedMessage defaultMessage="Starting shortly" />
            )}
            <FormattedMessage defaultMessage="..." />
          </div>
        </Then>
        <Else>
          <div className="starting-in">
            <FormattedMessage defaultMessage="Starting in" />
          </div>
          <ScheduleTimerComponent
            startTimeEpoch={webinarTimeEpoch}
            renderOnlyTimer
            onLiveCountdownZero={onLiveCountdownZero}
          />
        </Else>
      </If>
    </div>
  )
}

WaitingRoomCountdownComponent.propTypes = {
  webinarTimeEpoch: number,
  isHolding: bool,
  isWebinarTimeInThePast: bool,
  onLiveCountdownZero: func,
}
